// extracted by mini-css-extract-plugin
module.exports = {"error-message-description__label":"parts-diagram-error_error-message-description__label__ab6dR"};